import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import Card from '@material-ui/core/Card';
import Modal from '@material-ui/core/Modal';
import useStyles from './styles';
import * as Icons from '@material-ui/icons';
import Checkbox from '@material-ui/core/Checkbox';
// import { URL } from '~/config/uri';
import Request from '~/providers/Request';
import isBlank from '~/utils/isBlank';
import CurrentUser from '~/contexts/CurrentUser';

const ModalTerms = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [urlPrivacy, setUrlPrivacy] = useState('');
  const [urlTerms, setUrlTerms] = useState('');
  const [checked, setChecked] = useState(false);
  const { acceptedTermsAt, setAcceptedTermsAtContext } = useContext(CurrentUser);

  useEffect(()=> { searchEnvs(); }, []);

  const searchEnvs = async () => {
    try {
      let { data } = await Request.get('/public/env/PRIVACY_POLICY', null, { normalizeJSON: false });
      if(!isBlank(data?.url)) setUrlPrivacy(data.url);

      data = (await Request.get('/public/env/TERMS_OF_USE', null, { normalizeJSON: false })).data;
      if(!isBlank(data?.url)) setUrlTerms(data.url);

    } catch(e) { console.log('error', e); }
  };

  return (
    <Modal
      open={isBlank(acceptedTermsAt)}
      className={classes.modal}
      disableBackdropClick
      disableEscapeKeyDown
    >
      <Card
        classes={{
          root: classes.root,
        }}
      >
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
            <Icons.Edit style={{ fontSize: 100, marginBottom: 20, color: 'grey' }} />
            <div style={{ flexDirection: 'row' }}>
              <Checkbox
                value={checked}
                checked={checked}
                onChange={async (event) => {
                  if(event.target.value) setAcceptedTermsAtContext(new Date());
                  setChecked(!checked);
                }}
              />
              <span style={{ marginLeft: 10, fontSize: 20 }}>{t('i_agree')}</span>
            </div>
            <div style={{ flexDirection: 'column', }}>
              <div style={{ flexDirection: 'row', textAlign: 'center', marginTop: 20 }}>
                <a rel="noopener noreferrer" style={{ fontSize: 15, margin: 5, textDecorationLine: 'none' }} target='_blank' href={urlTerms}>{t('terms_of_use').toUpperCase()}</a>
                <span style={{ fontSize: 15, }}>{` ${t('and')} `}</span>
              </div>
              <a rel="noopener noreferrer" style={{ fontSize: 15, textDecorationLine: 'none' }} target='_blank' href={urlPrivacy}>{t('privacy_policy').toUpperCase()}</a>
            </div>
          </div>
      </Card>
    </Modal>
  );
};

export default ModalTerms;
